import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, statusBadge, statusLabel, totalsBlock, } from './record-parts.js';
/**
 * SAL-01's quotation as a printed document.
 *
 * What makes it a quotation and not an invoice: the VERSION (`revision_no`,
 * printed beside the number so a customer holding two copies can say which
 * one they accepted), the VALID-UNTIL date (an offer that has lapsed must say
 * so on the paper, not only on the screen), and the TERMS block — the
 * conditions the price is offered under, which the customer is signing up to
 * when they accept. No paid/due rail: nothing is owed on an offer.
 */
export function quotationHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    return html `
    ${header(company, t('quotationTitle', locale), statusBadge(data.status, locale))}
    ${fields([
        field(t('quotationNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.quotationDate)),
        field(t('revision', locale), ltr(String(data.revisionNo))),
        field(t('validUntil', locale), docDate(data.validUntil)),
        field(t('customerCode', locale), ltr(data.partnerCode)),
        field(t('status', locale), statusLabel(data.status, locale)),
        ...(data.reference === null || data.reference.trim() === ''
            ? []
            : [field(t('reference', locale), data.reference)]),
    ])}
    ${party(t('customer', locale), data.partnerName)}
    ${data.attention === null || data.attention.trim() === ''
        ? null
        : party(t('attention', locale), data.attention)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('terms', locale), data.terms)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=quotation.js.map